var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Login"},[_c('h1',[_vm._v("Sign In")]),_c('button',{on:{"click":_vm.login}},[_vm._v("Sign in with Github")]),_c('router-link',{attrs:{"to":"playground"}},[_vm._v("Use without account")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }